import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHomifyComponent } from './simple-icons-homify.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHomifyComponent ],
    exports:      [ SimpleIconsHomifyComponent ],
    bootstrap:    []
})
export class SimpleIconsHomifyModule {}
